import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import boost from '../../assets/img/boost.svg'
import BoostActivate from './boostactivate';
import BoostPaymentPlan from './boostpaymentplan';
import ls from "local-storage";
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class BoostPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boostactivatemodal: false,
            boostpaymentplanmodal: false,
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            user_details: '',
        };
    }

    componentDidMount() {
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey);
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({
                    user_details: user_details,
                });
            } else {
                this.props.history.push("/");
            }
        }).catch(error => {
            this.props.history.push("/"); 
        });
    }

    handleBoostActivateOpenModal = () => {
        if(this.state.user_details.boost_count === 0) {
            this.props.handleClose();
            this.handleBoostPaymentPlanOpenModal();
        } else {
            this.props.handleClose();
            this.setState({ boostactivatemodal: true });
        }
    }

    handleBoostActivateCloseModal = () => {
        this.setState({ boostactivatemodal: false });
    }

    handleBoostPaymentPlanCloseModal = () => {
        this.setState({ boostpaymentplanmodal: false });
    }

    handleBoostPaymentPlanOpenModal = () => {
        this.setState({ boostpaymentplanmodal: true });
    }

    render() {
        return (
            <>
                <div className="">
                    <Modal className="modal_div boostplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Body className="religion_modal">
                            <div className='boostplan_img'>
                                <img src={boost} alt="img" />
                            </div>
                            <div className='boostplan_content'>
                                <h4><Trans i18nKey="Skip the line">Skip the line</Trans></h4>
                                <p><Trans i18nKey="Be the top profile in your area for 30 minutes to get more matches.">Be the top profile in your area for 30 minutes to get more matches.</Trans></p>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="forgot_button_plr boostplan_button">
                            <Button className='boostplan_cancelbtn' onClick={this.props.handleClose}>
                            <Trans i18nKey="CANCEL">CANCEL</Trans>
                            </Button>
                            <Button className='button_primary ' onClick={this.handleBoostActivateOpenModal}>
                            <Trans i18nKey="BOOST ME">BOOST ME</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <BoostActivate
                    showModal={this.state.boostactivatemodal}
                    handleClose={this.handleBoostActivateCloseModal}
                />

                <BoostPaymentPlan
                    showModal={this.state.boostpaymentplanmodal}
                    handleClose={this.handleBoostPaymentPlanCloseModal}
                />
            </>
        );
    }
}

export default BoostPlan;
